import { List } from 'immutable';
import { AREA, BAR, COLUMN, COMBINATION, DATA_WELL, DONUT, GAUGE, LINE, PIE, TABLE, VENN } from '../../constants/chartTypes';
import { AGGREGATION, FUNNEL, PIPELINE, TIME_SERIES } from '../../constants/configTypes';
// @ts-expect-error Untyped import
import { getBlocklistedForDrilldown } from '../../public/blocklisted-for-drilldown';
import { drilldownGenerators, hasSupportedGeneratorAsync } from './generators';
import { getDataType, getReportChartType } from '../../report/reportGetters';
const isSupportedConfigType = configType => {
  return [AGGREGATION, TIME_SERIES, FUNNEL, PIPELINE].includes(configType);
};
const isSupportedChartType = chartType => {
  return [TABLE, DATA_WELL, BAR, AREA, LINE, COLUMN, DONUT, PIE, FUNNEL, COMBINATION, GAUGE, VENN].includes(chartType);
};
const BLOCKLISTED_DATATYPES = ['EXT_SMS_ANALYZE_OVERVIEW', 'EXT_SMS_ANALYZE_FUNNEL_CHART', 'EXT_SMS_ANALYZE_TIME_SERIES'];
const isSupportedDataType = (report, dataTypeModule) => {
  return hasSupportedGeneratorAsync(report, dataTypeModule).then(hasSupportedGenerator => (hasSupportedGenerator || getReportChartType(report) !== TABLE) && !BLOCKLISTED_DATATYPES.includes(getDataType(report)));
};
export const isSupported = (report, dataTypeModule) => {
  const configType = report.getIn(['config', 'configType']);
  const chartType = getReportChartType(report);
  const dataType = getDataType(report);
  return isSupportedDataType(report, dataTypeModule).then(dataTypeIsSupported => {
    if (!isSupportedConfigType(configType) || !isSupportedChartType(chartType) || !dataTypeIsSupported) {
      return false;
    }
    return getBlocklistedForDrilldown(dataType).then(blocklistedForDrilldown => Boolean(report.getIn(['config', 'dimensions'], List()).findIndex(dimensionProperty => blocklistedForDrilldown.includes(dimensionProperty)) === -1));
  });
};
export const isSupportedColumn = (report, column, dataTypeModule) => {
  return drilldownGenerators.some(gen => gen.isSupportedColumn && gen.isSupportedColumn(report, column, dataTypeModule) || false);
};